import $ from "jquery";
import Slider from "@/shared/slider";

// カルーセルスライダー
export const sliderSetting = (nobreak, dots) => {
  const slider = new Slider(nobreak, dots);
  slider.apply();
};

// 日付ごとのカラー設定
export const setColorClass = () => {
  const subBgClass = "background-color--sub";
  const sunBgClass = "background-color--calendar_sun_bg";
  const satBgClass = "background-color--calendar_sat_bg";
  const pageBgClass = "background-color--page_bg";

  $(".calendar__day-item").each((idx, elem) => {
    const $this = $(elem);
    $this
      .removeClass(subBgClass)
      .removeClass(sunBgClass)
      .removeClass(satBgClass)
      .removeClass(pageBgClass);

    $this
      .find(".calendar__day-check-inner")
      .removeClass(subBgClass)
      .removeClass(sunBgClass)
      .removeClass(satBgClass)
      .removeClass(pageBgClass);

    // 定休日は選択済み色より優先してグレーアウトするため色クラスを付けない
    if ($this.hasClass("is-regular-holiday")) {
      return;
    }

    if ($this.find(".calendar__day-input").prop("checked")) {
      $this.addClass(subBgClass);
      $this.find(".calendar__day-check-inner").addClass(subBgClass);
    } else if ($this.hasClass("is-holiday")) {
      $this.addClass(sunBgClass);
      $this.find(".calendar__day-check-inner").addClass(sunBgClass);
    } else if ($this.hasClass("is-sat")) {
      $this.addClass(satBgClass);
      $this.find(".calendar__day-check-inner").addClass(satBgClass);
    } else {
      $this.addClass(pageBgClass);
      $this.find(".calendar__day-check-inner").addClass(pageBgClass);
    }
  });
};

$(() => {
  // カラー設定
  setColorClass();

  $(".calendar__day-input").on("change", () => {
    setColorClass();
  });
});
